import { LABELS } from '@/constants/common/message.constants'

import { type PartnerEntity } from '../../aspida/@types'

/**
 * 銀行口座種別
 */
export type BankAccountType = NonNullable<PartnerEntity['bankAccountType']>

export const BANK_ACCOUNT_TYPE = {
  /** 普通 */
  SAVINGS: 'SAVINGS',
  /** 当座 */
  CHECKING: 'CHECKING'
} as const satisfies Record<BankAccountType, BankAccountType>

export const BANK_ACCOUNT_TYPE_LABEL = {
  [BANK_ACCOUNT_TYPE.SAVINGS]: LABELS.BANK_ACCOUNT_TYPE_SAVINGS,
  [BANK_ACCOUNT_TYPE.CHECKING]: LABELS.BANK_ACCOUNT_TYPE_CHECKING
} as const satisfies Record<BankAccountType, string>

export function getBankAccountTypeLabel(type: BankAccountType): string {
  return BANK_ACCOUNT_TYPE_LABEL[type]
}
